export default __webpack_public_path__ + "static/dumpster3-4fda86f1a128bd7313e7840ed4ae06c3.png";